var config = {};
export {
  config as __exports
};
//# sourceMappingURL=config2.js.map
